// extracted by mini-css-extract-plugin
export var border = "_2a-8";
export var brand = "_2a-t";
export var button = "_2a-l";
export var center = "_2a-a";
export var centered = "_2a-6";
export var closeButton = "_2a-c";
export var disabledWrapper = "_2a-m";
export var error = "_2a-p";
export var extraLarge = "_2a-4";
export var extraSmall = "_2a-1";
export var fill = "_2a-i";
export var footer = "_2a-h";
export var footerAction = "_2a-j";
export var footerButtons = "_2a-k";
export var header = "_2a-7";
export var headerWithClose = "_2a-d";
export var icon = "_2a-o";
export var info = "_2a-s";
export var inline = "_2a-9";
export var large = "_2a-3";
export var main = "_2a-e";
export var modal = "_2a-0";
export var nearFull = "_2a-5";
export var neutral = "_2a-u";
export var noPadding = "_2a-g";
export var none = "_2a-v";
export var scrollable = "_2a-f";
export var small = "_2a-2";
export var success = "_2a-r";
export var tight = "_2a-n";
export var titleIcon = "_2a-b";
export var warn = "_2a-q";